<div class="error-page">
  <div class="error-page__inner">
    <a routerLink="/" class="error-page__logo">
      <img src="assets/images/rackeo/marca/logo.svg" alt="Rackeo - Hosting, VPS y Servidores Dedicados" height="48" />
    </a>
    <p class="error-page__code">404</p>
    <h1 class="error-page__title">Página no encontrada</h1>
    <p class="error-page__text">
      Es posible que la página que buscas haya sido movida, eliminada o que nunca haya existido.
    </p>
    <a routerLink="/" class="error-page__btn">Volver al inicio</a>
  </div>
</div>
